<template>
  <div  class="page h-100">
    <div class="container pt-82">
      <div class="font-40 color-ff font-yahei text-center mb-4">整装方案</div>
      <div class=" font-yahei font-16 color-94 text-center mb-90">5000+产品模型、100+精选知名品牌、500+设计师独家打造</div>
      <div class="menu flex">
        <div class="flex-1 plr-30 flex-column justify-center">
          <div class="flex align-start">
            <img src="/images/xuanxiang-fengge.png" alt="" class="mr-10">
            <div class="font-16 color-292a2e font-yahei">风格</div>
            <div class="line"></div>
            <div class="flex-wrap flex-1 w-0 flex">
              <button class="menu-item font-12" :class="styleIndex === -1 ? 'active' : ''" @click="chooseMenu(-1, 'styleIndex')">不限</button>
              <button class="menu-item font-12" :class="styleIndex === index ? 'active' : ''" v-for="(item, index) in styleList" :key="index" @click="chooseMenu(index, 'styleIndex')">{{item.name}}</button>
            </div>
          </div>
          <div class="hr-dashed"></div>
          <div class="flex align-start">
            <img src="/images/xuanxiang-fangxing.png" alt="" class="mr-10">
            <div class="font-16 color-292a2e font-yahei">房型</div>
            <div class="line"></div>
            <div class="flex-wrap flex-1 w-0 flex">
              <button class="menu-item font-12" :class="layoutIndex === -1 ? 'active' : ''" @click="chooseMenu(-1, 'layoutIndex')">不限</button>
              <button class="menu-item font-12" :class="layoutIndex === index ? 'active' : ''" v-for="(item, index) in layoutList" :key="index" @click="chooseMenu(index, 'layoutIndex')">{{item.name}}</button>
            </div>
          </div>
          <div class="hr-dashed"></div>
          <div class="flex align-start">
            <img src="/images/xuanxiang-fangan.png" alt="" class="mr-10">
            <div class="font-16 color-292a2e font-yahei">方案</div>
            <div class="line"></div>
            <div class="flex-wrap flex-1 w-0 flex">
              <button class="menu-item font-12" :class="schemeIndex === -1 ? 'active' : ''" @click="chooseMenu(-1, 'schemeIndex')">不限</button>
              <button class="menu-item font-12" :class="schemeIndex === index ? 'active' : ''" v-for="(item, index) in schemeList" :key="index" @click="chooseMenu(index, 'schemeIndex')">{{item.name}}</button>
            </div>
          </div>
        </div>
        <div class="menu-right flex-column justify-center" v-if="!isLogin">
          <div class="flex align-center mb-12"><img src="/images/yuyuefangan.png" alt=""><span class="font-12 color-292a2e font-yahei ml-10">预约方案设计</span></div>
          <div class="input mb-10"><el-input v-model="user.username" placeholder="您的姓名"></el-input></div>
          <div class="input mb-10"><el-input v-model="user.telephone" placeholder="您的电话"></el-input></div>
          <div class="btn-30 bg-292a2e radius-round color-ff font-16 font-yahei" @click="toAppointment">立即预约</div>
        </div>
        <div v-else class="menu-right flex-column align-center justify-center">
          <el-image
            style="width: 60px; height: 60px"
            src="/images/yiyuyue.png"
            fit="cover"></el-image>
          <div class="color-292a2e font-16 font-yahei mt-5">已预约方案设计</div>
        </div>
      </div>
      <div class="flex align-center mb-30">
        <img src="/images/weizhi.png" alt="" class="mr-10">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/index.html' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>整装方案</el-breadcrumb-item>
          <el-breadcrumb-item>
            <div>
              <div class="bg-f6efe6"></div>
              共{{total}}个整装方案
            </div>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="hr mb-10"></div>
      <div class="flex align-center sort mb-30">
        <button class="font-12 cursor" :class="isSales === '' && isPrice === '' ? 'color-c19357' : 'color-94'" @click="onSort('')">综合排序</button>
        <div class="line"></div>
        <button class="flex align-center font-12 cursor" :class="isSales !== '' ? 'color-c19357' : 'color-94'" @click="onSort('isSales')">
          销量
          <img :src="isSales === 1  ? '/images/paixu-jiangxu.png' : isSales === 0 ? '/images/paixu-shengxu.png' : '/images/paixu.png'" class="ml-5">
        </button>
        <div class="line"></div>
        <button class="flex align-center font-12 cursor" :class="isPrice !== '' ? 'color-c19357' : 'color-94'" @click="onSort('isPrice')">
          价格
          <img :src="isPrice === 1  ? '/images/paixu-jiangxu.png' : isPrice === 0 ? '/images/paixu-shengxu.png' : '/images/paixu.png'" class="ml-5">
        </button>
      </div>
      <div class="flex flex-wrap mb-40">
        <scheme-item v-for="(item, index) in planList" :planItem="item" :key="index" :index="index"></scheme-item>
      </div>
      <el-pagination layout="prev, pager, next" :total="total" @current-change="handleCurrentChange"></el-pagination>
    </div>
    <div class="modal" v-if="appointmentSuccess" @scroll.stop.prevent @touchmove.prevent>
      <div class="flex-column content">
        <div class="flex justify-end p-10">
          <img src="/images/guanbi.png" alt="" @click="onClose" class="cursor">
        </div>
        <div class="flex-1 flex-column align-center justify-center">
          <img src="/images/chenggong.png" alt="" class="mb-16">
          <div class="font-22 color-292a2e font-yahei mb-4">预约成功</div>
          <div class="font-14 color-94 font-yahei mb-18">请保持手机畅通，鲁班工作人员会尽快联系您！</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SchemeItem from '@/components/SchemeItem'
export default {
  name: 'OverallScheme',
  components: {SchemeItem},
  props: ['keywords'],
  computed: {
  },
  data () {
    return {
      isLogin: this.$store.state.token,
      user: {
        username:'',
        telephone: '',
        password: '',
        code: '',
      },
      styleList: [],
      layoutList: this.Utils.houseType,
      schemeList: [{
        name: '超值方案'
      }, {
        name: '刚需方案'
      }, {
        name: '品质方案'
      }, {
        name: '高端方案'
      }],
      styleIndex: -1,
      layoutIndex: -1,
      schemeIndex: -1,
      isSales: '',
      isPrice: '',
      appointmentSuccess: false,
      page:1,
      limit: 12,
      total:0,
      planList: []
    }
  },
  created () {
    this.getStyle()
    this.getData()
    if (this.$store.state.token && this.$store.state.user) {
      this.getMyCase()
    }
  },
  watch: {
    keywords (val) {
      this.keywords = val
      this.getData()
    }
  },
  mounted () {
  },
  methods: {
    getStyle() {
      this.axios
        .post("style/list",{})
        .then(res => {
          if (res.data.success) {
            this.styleList = res.data.data;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
              offset: 400
            });
          }
        });
    },
    getMyCase() {
      this.axios
        .post("customerProgramme/list",{})
        .then(res => {
          if (res.data.success) {
            this.schemeList = res.data.data;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
              offset: 400
            });
          }
        });
    },
    getData () {
       this.axios.post(`programme/queryForPage`, {
        styleId: this.styleIndex >=0 ? this.styleList[this.styleIndex].id : '',
        layout:  this.layoutIndex >=0 ? this.layoutList[this.layoutIndex].name : '',
        keywords: this.keywords,
        limit: this.limit,
        page: this.page
      }).then(res => {
        if (res.data.success) {
          let list = res.data.data.list
          this.planList = list
          this.total = res.data.data.total
        }
      })
    },
    handleCurrentChange (e) {
      console.log(e)
    },
    chooseMenu (e, key) {
      this[key] = e
      this.getData()
    },
    onSort (key) {
      if (!key) {
        this.isSales = ''
        this.isPrice = ''
      } else {
        switch (this[key]) {
          case '':
            this.isSales = ''
            this.isPrice = ''
            this[key] = 1
          break
          case 1:
            this[key] = 0
          break
          case 0:
            this[key] = 1
        }
      }
    },
    toAppointment () {
      // console.log(this.$parent.$parent)
      this.$parent.$parent.isRegister = true
      this.$parent.$parent.user = this.user
      // this.appointmentSuccess = true
    },
    onClose () {
      this.appointmentSuccess = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .page{
    background: #eeeff3 url('/images/zhengzhuangfanganbg.png') no-repeat top center/auto 335px;
    padding-bottom: 105px;
  }
  .menu{
    background: #fff;
    border-radius: 4px;
    height: 200px;
    box-shadow: 0px 30px 70px 0px rgba(41, 42, 46, 0.07);
    margin-bottom: 32px;
    .menu-right{
      background-color: #c19357;
      border-radius: 4px;
      padding: 0 30px;
      width: 242px;
    }
    .input{
      width: 100%;
      height: 30px;
      border-radius: 20px;
      overflow: hidden;
    }
    .line{
      height: 24px;
      width: 1px;
      background: #e9e9e9;
      margin: 0 20px;
    }
    .menu-item{
      padding: 0 10px;
      height: 20px;
      line-height: 20px;
      border-radius: 10px;
      color: #7d7d7d;
      cursor: pointer;
      margin-right: 10px;
      margin-bottom: 5px;
    }
    .active{
      background: #f6efe6;
      color: #c19357;
    }
  }
  .sort{
    .line{
      width: 1px;
      height: 12px;
      background: #e9e9e9;
      margin: 0 20px;
    }
    button {
      padding: 0;
    }
  }

  .hr-dashed{
    width: 100%;
    height: 1px;
    border-bottom: 1px dashed #e9e9e9;
    margin: 14px 0;
  }
  .modal{
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba($color: #000000, $alpha: 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    .content{
      width: 394px;
      height: 255px;
      background: #ffffff;
      border-radius: 4px;
    }
  }
  ::v-deep{
    .el-input__inner{
      height: 30px;
      line-height: 30px;
      font-size: 12px;
      border: 0;
      background: #fff;
    }
    .el-input.is-active .el-input__inner, .el-input__inner:focus{
      border: 0;
    }
  }
</style>
